<script>
  import Documentation from '../../components/Documentation.svelte';

  export let id;
</script>

<div>
  <Documentation {id} />
</div>

<style type="text/scss">
  div {
    padding: 20px;
  }
</style>